import type { Plan } from "@circle-react/types";
import { Button } from "@circle-react-uikit/Button";
import { useSubmitButton } from "./useSubmitButton";

export interface SubmitButtonProps {
  plan: Plan;
}

export const SubmitButton = ({ plan }: SubmitButtonProps) => {
  const buttonConfig = useSubmitButton(plan);

  return (
    <Button
      variant={buttonConfig.variant}
      large
      onClick={buttonConfig.handler}
      disabled={buttonConfig.disabled}
      data-testid={buttonConfig.testId}
    >
      {buttonConfig.text}
    </Button>
  );
};
